<template>
  <header class="clearfix">
    <h1><router-link :to="'/'">
      <img v-if="$store.state.auth.typeOfUser === 'pharmacy'" :src="'/common/img/nanacara_logo.png'" alt="nanacara for Pharmacy" height="30">
      <img v-else :src="'/common/img/logo.png'" alt="nanacara for Docotor" height="30">
    </router-link></h1>
</header>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>